import i18n from '@/i18n';

export const formatTime = (hour: string): string => {
  if (hour === '*') return '';

  if (hour === '0') return '12AM';

  const hourNum = Number(hour);
  const displayHour = hourNum % 12 || 12;
  const ampm = hourNum >= 12 ? 'PM' : 'AM';
  return `${displayHour}${ampm}`;
};

export const formatDay = (dayWeek: string): string => {
  if (dayWeek === '*') return '';

  const days: { [key: string]: string } = {
    0: i18n.t('monitor_wizard.run_schedule.run_schedule_options.sunday'),
    1: i18n.t('monitor_wizard.run_schedule.run_schedule_options.monday'),
    2: i18n.t('monitor_wizard.run_schedule.run_schedule_options.tuesday'),
    3: i18n.t('monitor_wizard.run_schedule.run_schedule_options.wednesday'),
    4: i18n.t('monitor_wizard.run_schedule.run_schedule_options.thursday'),
    5: i18n.t('monitor_wizard.run_schedule.run_schedule_options.friday'),
    6: i18n.t('monitor_wizard.run_schedule.run_schedule_options.saturday'),
  };

  return days[dayWeek] || '';
};

export const formatSchedule = (schedule: string): string => {
  if (!schedule) return '';

  // Handle special cases
  if (schedule === '@hourly') return i18n.t('monitor_wizard.run_schedule.run_schedule_options.hourly');

  // Handle cron expression
  const [_minute, hour, _dayMonth, _month, dayWeek] = schedule.split(' ');

  const time = formatTime(hour);
  const day = formatDay(dayWeek);

  // Format the final string
  if (schedule === '@daily') {
    return `Daily: ${time}`;
  }
  if (schedule === '@weekly') {
    return `Weekly: ${i18n.t('monitor_wizard.run_schedule.run_schedule_options.monday')} ${time}`;
  }
  if (dayWeek !== '*') {
    return `Weekly: ${day} ${time}`;
  }
  if (hour !== '*') {
    return `Daily: ${time}`;
  }

  return '';
};
